import React from "react";

import Skeleton from "react-loading-skeleton";

const StringCell: React.FC<StringCellProps> = ({ value }) => {
  return (
    <>
      {value === undefined ? (
        <Skeleton />
      ) : (
        <div>{value && value !== "" ? value : "---"}</div>
      )}
    </>
  );
};

export default StringCell;

export interface StringCellProps {
  value: string | undefined;
}
